import store from "store/store"

export const updateUserDetail = (user) => {
    store.dispatch({
        type: 'USER_DETAIL',
        value: user
    })
}
